import classes from "./Shimmer.module.css";

function Shimmer({ cards }) {
	return (
		<div className={classes.main}>
			<div className={classes.img}></div>
			<div className={classes.name}></div>
			<div className={classes.price}></div>
			<div className={classes.cartBtn}></div>
		</div>
	);
}

export default Shimmer;
